var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 7.567C27.895 7.0225 21.7533 6.742 15.63 6.742C12 6.742 8.37 6.907 4.74 7.237L1 7.567M11.0833 5.9005L11.4867 3.739C11.78 2.1715 12 1 15.0983 1H19.9017C23 1 23.2383 2.2375 23.5133 3.7555L23.9167 5.9005M30.0583 12.781L28.8667 29.3965C28.665 31.987 28.5 34 23.385 34H11.615C6.5 34 6.335 31.987 6.13333 29.3965L4.94167 12.781M14.4383 24.925H20.5433M12.9167 18.325H22.0833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.32862bc82501b0726c2d935e48a5b74e.svg";
export { ForwardRef as ReactComponent };